$(document).ready(function() {
    $('#search_category_name').on('click', function() {
        $('.mega-select').toggleClass('open');
    });

    $('.mega-select li').on('click', function(e) {
        $('#search_category_name').addClass('has-value');
        $('#search_category_name').html($(this).html());
        $('#search_category_slug').val($(this).data('category-slug'));
        $('.mega-select').removeClass('open');
    });

    $(document).click(function(event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".mega-select").length) {
            $('.mega-select').removeClass('open');
        }
    });
});
